import { c as _c } from "react/compiler-runtime";
import { ArrowRight, BadgeDollarSign, ShoppingCart, Sprout, TrendingUp } from 'lucide-react';
const OUTCOMES = [{
  icon: TrendingUp,
  title: 'Demand',
  description: 'People actively want your product'
}, {
  icon: ShoppingCart,
  title: 'Sales',
  description: 'They pick it off the shelf'
}, {
  icon: BadgeDollarSign,
  title: 'Revenue',
  description: 'Sales hit your bank account'
}, {
  icon: Sprout,
  title: 'Growth',
  description: 'You reinvest and scale'
}];
export function DemandToBusinessSection() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-auto max-w-4xl text-center"><h2 className="mt-3 text-3xl font-black tracking-tight text-gray-950 sm:text-4xl">Demand isn't the end goal. It's the start of every sale.</h2></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="border-b border-gray-200 bg-white py-10 sm:py-14"><div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">{t0}<div className="mx-auto mt-8 grid max-w-6xl grid-cols-1 items-stretch gap-3 lg:grid-cols-[1fr_auto_1fr_auto_1fr_auto_1fr]">{OUTCOMES.map(_temp)}</div></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function _temp(t0, index) {
  const {
    icon: Icon,
    title,
    description
  } = t0;
  return <div key={title} className="contents"><div className="flex items-center gap-4 rounded-2xl border border-gray-200 bg-[#fffaf4] p-5 shadow-sm lg:flex-col lg:items-start"><span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600"><Icon className="h-6 w-6" aria-hidden="true" /></span><div><h3 className="font-extrabold text-gray-950">{title}</h3><p className="mt-1 text-sm leading-5 text-gray-600">{description}</p></div></div>{index < OUTCOMES.length - 1 && <div className="flex items-center justify-center py-1 text-primary-500 lg:px-1 lg:py-0"><ArrowRight className="h-5 w-5 rotate-90 lg:rotate-0" aria-hidden="true" /></div>}</div>;
}